<template>
	<div class="page-content">
		<div class="container">
			<!-- 第一行：参与需知 / 倒计时 / 流水明细 -->
			<div class="card section">
				<div class="row" style="padding:14px">
					<button class="btn btn-link" @click="ParticipationGuidelines = true" data-lang="t_36"></button>
					<div style="text-align:center">
						<div class="title" data-lang="t_37"></div>
						<div class="h2" style="margin-top:4px;font-size: 12px;color: #F00;">{{productionCut}}</div>
					</div>
					
				</div>
			</div>

			<div class="card" style="margin-top: 15px;">
				<!-- 第二行：我的节点 / 节点利润（左右） -->
				<div class="grid grid-2 section">
					<div class="pad" style="text-align:center">
						<div class="title" data-lang="t_38"></div>
						<div class="h1" style="margin-top:6px">{{totalMine}}</div>
					</div>
					<div class="pad" style="text-align:center">
						<div class="title" data-lang="t_39"></div>
						<div class="h1" style="margin-top:6px">{{totalMineProfit}}</div>
					</div>
				</div>

				<!-- 第三行：三块 -->
				<div class="grid grid-3 section" style="background:rgba(255,255,255,0.1);border-radius: 12px;">
					<div class="pad" style="text-align:center;border:none;background: rgba(255,255,255,0);">
						<div class="title" data-lang="t_40"></div>
						<div class="h2" style="margin-top:6px">{{totalAlreadyFree/100}}</div>
					</div>
					<div class="pad" style="text-align:center;border:none;background: rgba(0,0,0,0);">
						<div class="title" data-lang="t_41"></div>
						<div class="h2" style="margin-top:6px">{{speedFree}}</div>
					</div>
					<div class="pad" style="text-align:center;border:none;background: rgba(0,0,0,0);">
						<div class="title" data-lang="t_42"></div>
						<div class="h2" style="margin-top:6px">{{totalWaitFree}}</div>
					</div>
				</div>
			</div>

			<!-- 第五行：9个节点控件 -->
			<div class="card section">
				<div class="row" style="padding:14px">
					<div class="h2" data-lang="t_3"></div>
					<button class="btn btn-primary" @click="oneKeyTakeProfit()" data-lang="t_43"></button>
				</div>
				<div class="list" style="padding:14px" @scroll="handleContainerScroll">
					<div class="node" v-for="(item, index) in nodeData" :key="index"
						style="padding: 12px;margin: 12px 0px;" :class="{node_active:item.isActive == 3}"
						v-if="index <= 5 || (index == 7 && (UserType == -1 || UserType == 3))"
						>
						<div class="nodeHead">
							<div class="nodeName">{{item.name}}</div>
							<div class="v">{{item.MineType}}</div>
						</div>

						<div class="row" style="margin-top:10px">
							<div>
								<div class="k" data-lang="t_44"></div>
								<div class="v">
									{{item.alreadyFree}}
									/
									{{item.totalFree}}
								</div>
							</div>
							<div style="text-align:center">
								<div class="k" data-lang="t_45"></div>
								<div class="v">
									{{item.alreadFreeDay}}
									/
									{{item.totalFreeDay}}
								</div>
							</div>
							<div>
								<button v-if="item.btnCaption != 'hide'" class="btn btn-mini"
									:class="{'btn-primary' : item.isActive == 2,'btn-active':item.isActive == 3}"
									@click="onNodeBtnClick(index)">{{item.btnCaption}}</button>
							</div>
						</div>
						<div class="row" style="margin-top:10px;text-align:center">
							<div>
								<div class="k" data-lang="t_46"></div>
								<div class="v">
									{{item.waitTakeProfit}}
								</div>
							</div>
							<div style="text-align:center">
								<div class="k" data-lang="t_47"></div>
								<div class="v">
									{{item.buyTime == 0?"~":timeToString(item.buyTime)}}
								</div>
							</div>
							<div style="text-align:center;">
								<div class="k" data-lang="t_48"></div>
								<div class="v">
									{{item.takeTime == 0?"~":timeToString(item.takeTime)}}
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<!-- 激活节点对话框 -->
		<div class="modalMask" :class="{show:isShowBuyNodeBox == true}">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_49"></div>
					<div class="modalClose" id="radio_close_btn">×</div>
				</div>
				<div class="modalBody">
					<div id="radio-container">
						<p id="radio-subtitle">{{buyNodeName}}</p>

						<label class="radio-option" @click="radioSelect = 1">
							<div class="radio-content">
								<p class="radio-label" data-lang="t_50"></p>
								<p class="radio-desc" ><span data-lang="t_51"></span>: <span id="user_in_balance">{{balanceOfAccount}}</span> A</p>
							</div>
							<input type="radio" class="radio-input" :checked="radioSelect == 1">
						</label>

						<label class="radio-option" @click="radioSelect = 2">
							<div class="radio-content">
								<p class="radio-label" data-lang="t_52"></p>
								<p class="radio-desc" ><span data-lang="t_53"></span>: <span id="user_out_balance">{{balanceOfAGE}}</span> A</p>
							</div>
							<input type="radio" class="radio-input" :checked="radioSelect == 2">
						</label>

						<label class="radio-option" @click="radioSelect = 3">
							<div class="radio-content">
								<p class="radio-label" data-lang="t_54"></p>
							</div>
							<input type="radio" class="radio-input" :checked="radioSelect == 3">
						</label>
					</div>
				</div>
				<div class="modalFoot">
					<button class="btn" id="radio_cancel_btn" data-lang="t_55"></button>
					<button class="btn btn-primary" id="radio_ok_btn" data-lang="t_56"></button>
				</div>
			</div>

		</div>
		<!-- 参与需知（全屏） -->
		<div class="modalMask fullscreen" :class="{ show: ParticipationGuidelines == true }">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_57"></div>
					<div class="modalClose" @click="ParticipationGuidelines = false">×</div>
				</div>
				<div class="modalBody">
					<div class="h2" data-lang="t_58"></div>
					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_59">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_60">
							
						</div>
					</div>

					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_61">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_62">
							
						</div>
					</div>

					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_63">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_64">
							
						</div>
					</div>

					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_65">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_66">
							
						</div>
					</div>

					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_67">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_68">
							
						</div>
					</div>
					<div class="h2" data-lang="t_69"></div>
					<div class="item_1" style="margin: 0px 0px;">
						<div class="v" style="text-align: left;" data-lang="t_70">
							
						</div>
						<div class="k" style="text-align: left;" data-lang="t_71">
							
						</div>
					</div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="ParticipationGuidelines = false" data-lang="t_56"></button>
				</div>
			</div>
		</div>

		
	</div>
</template>

<script>
	export default {
		name: 'Node',
		data() {
			return {
				nodeData: [{
					name: Lang[lg].t_72,
					id: 0,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 130,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_74,
					id: 1,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 390,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_75,
					id: 2,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 650,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_76,
					id: 3,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 1300,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_77,
					id: 4,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 3900,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_78,
					id: 5,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 6500,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_79,
					id: 6,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 13000,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_34,
					id: 7,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 39000,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, {
					name: Lang[lg].t_81,
					id: 8,
					buyTime: "",
					takeTime: "",
					alreadyFree: 0,
					totalFree: 65000,
					alreadFreeDay: 0,
					totalFreeDay: 0,
					waitTakeProfit: "~",
					btnCaption: Lang[lg].t_73,
				}, ],
				isShowBuyNodeBox: false, //是否显示激活节点对话框
				buyNodeName: "", //激活节点的名字
				balanceOfAGE: 0, //余额
				balanceOfAccount: 0, //账户余额
				radioSelect: 3, //选择按钮
				ParticipationGuidelines: false, //参与需知
				
				totalMine: 0, //我的节点
				totalMineProfit: 0, //所有节点的利润
				totalAlreadyFree: 0, //所有已释放
				totalWaitFree: 0, //所有待释放
				speedFree: 0, //加速释放
				maxMineId: 0, //最大节点
				
				
				openTime: 0,
				productionCutTime: 0, //上次减产时间
				Interval: 0,
				TimeOut: 0, //从开启程序到现在经过了多少时间
				currentTime: 0,
				productionCut: 0, //距离减产倒计时
				
				UserType:-1,
				UserID:0,
			}
		},
		mounted() {
			
			this.showUI();
			this.setLanguage();
		},
		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			handleContainerScroll(e) {
				const {
					scrollTop,
					clientHeight,
					scrollHeight
				} = e.target;
				// console.log("scrollTop + clientHeight="+(scrollTop + clientHeight)+"scrollHeight="+scrollHeight)
				// 判断是否滚动到底部
				if (scrollTop + clientHeight >= scrollHeight - 12) {
					
				}
			},
			
			timeToString(time) {
				const t = new Date(time * 86400000);
				return t.toLocaleString('zh-CN', {
					year: 'numeric', // 四位数年份
					month: '2-digit', // 两位数月份
					day: '2-digit', // 两位数日期
				});
			},
			getMinePrice(index) {
				if (index == 0) return 100;
				else if (index == 1) return 300;
				else if (index == 2) return 500;
				else if (index == 3) return 1000;
				else if (index == 4) return 3000;
				else if (index == 5) return 5000;
				else if (index == 6) return 10000;
				else if (index == 7) return 30000;
				else if (index == 8) return 50000;
			},
			async showUI() {
				//获取时间
				this.currentTime = await conHis.getTime().call();
				await Sleep(this.$waitTime);
				const sysInfo = await conMine.getSysInfo().call();
				this.productionCutTime = Number(sysInfo.addPeriodDay) * 86400 + 180 * 86400;
				var that = this;
				if (this.Interval == 0) {
					this.Interval = setInterval(function() {
						that.TimeOut++;
						const t = (Number(that.currentTime) + Number(that.TimeOut));
						const sub = that.productionCutTime - t;
						const day = Math.floor(sub / 86400).toString();
						const hour = Math.floor(sub % 86400 / 3600).toString().padStart(2, "0");
						const minute = Math.floor(sub % 3600 / 60).toString().padStart(2, "0");
						const second = Math.floor(sub % 60).toString().padStart(2, "0");
						that.productionCut = day + "-" + hour +　":" + minute + ":" + second 
					}, 1000);
				}

				//首先读取我的节点
				//获取节点信息
				await Sleep(this.$waitTime);
				const userMine = await conMine.getUserMine(Account).call();
				let mine = {
					"isActive": 0,
					"period": 0,
					"buyTime": 0,
					"takeTime": 0,
					"alreadFree": 0
				}
				const data = userMine.m1.substring(2, 66) + userMine.m2.substring(2, 66) + userMine.m3.substring(2,
					66) + userMine.m4.substring(2, 66);
				const len = data.length;
				let point = 0;
				let maxActive = -1;
				let maxMine;
				this.totalAlreadyFree = 0;
				this.totalWaitFree = 0;
				this.speedFree = 0;


				for (let i = 0; i < 9; i++) {
					mine.isActive = Number("0x" + data.substring(point, point + 2));
					point += 2;
					mine.period = Number("0x" + data.substring(point, point + 2));
					point += 2;
					mine.buyTime = Number("0x" + data.substring(point, point + 4));
					point += 4;
					mine.takeTime = Number("0x" + data.substring(point, point + 4));
					point += 4;
					mine.alreadFree = Number("0x" + data.substring(point, point + 8));
					point += 8;
					mine.isAddSeedForUpNode = data.substring(point, point + 4)
					point += 4;
					this.nodeData[i].buyTime = mine.buyTime;
					this.nodeData[i].takeTime = mine.takeTime;
					this.nodeData[i].alreadyFree = Number(mine.alreadFree) / 100;
					this.nodeData[i].totalFreeDay = mine.period;
					this.nodeData[i].alreadFreeDay = mine.takeTime - mine.buyTime;
					this.nodeData[i].isActive = mine.isActive;
					this.nodeData[i].period = mine.period;
					if (mine.isActive == 0 || mine.isActive == 1) this.nodeData[i].MineType = Lang[lg].t_82;
					else if (mine.isActive == 2) this.nodeData[i].MineType = Lang[lg].t_82;
					else if (mine.isActive == 3) this.nodeData[i].MineType = Lang[lg].t_83;
					//获取最大节点
					if (mine.isActive == 3 && maxActive < i) {
						maxActive = i;
					}
					
					if (mine.isActive == 0 || mine.isActive == 1) {
						this.nodeData[i].btnCaption = Lang[lg].t_73;
						this.nodeData[i].waitTakeProfit ='~'
					} else if (mine.isActive == 2) {
						this.nodeData[i].btnCaption = Lang[lg].t_84;
						this.nodeData[i].waitTakeProfit = "~"
					} else if (mine.isActive == 3) {

						let day = Math.floor(this.currentTime / 86400);
						//取矿日期
						day = day - mine.takeTime;
						//每日产出 = 总产出/周期
						let profit = this.getMinePrice(i) * 1.3 / mine.period * day;
						if (day <= 0) profit = 0;
						if (profit + this.nodeData[i].alreadyFree > this.getMinePrice(i) * 1.3) {
							profit = this.getMinePrice(i) * 1.3 - this.nodeData[i].alreadyFree
						}
						this.nodeData[i].waitTakeProfit = Math.floor(profit * 100) / 100;

						this.totalAlreadyFree += mine.alreadFree;

						if (profit == 0) this.nodeData[i].btnCaption = "hide";
						else this.nodeData[i].btnCaption = Lang[lg].t_85;
					}

				}
				await Sleep(this.$waitTime);
				const user = await conMine.getPeopleTree(Account).call();
				this.UserType = user.Type;
				this.UserID = user.id;
				//计算最大节点
				maxMine = this.nodeData[maxActive];
				if (maxActive >= 0) {

					//补上待取的
					let day = Math.floor(this.currentTime / 86400) - user.speedTakeTime;
					
					let speedProfit = Number(user.speedProfit) + user.speed * day;
					speedProfit = Math.round(speedProfit) / 100;
					//获得当前应释放
					let freeProfit = this.nodeData[maxActive].waitTakeProfit;
					let maxFree = this.getMinePrice(maxActive) * 1.3;
					if (freeProfit + maxMine.alreadyFree + speedProfit < maxFree) {
						this.nodeData[maxActive].waitTakeProfit = freeProfit + speedProfit;
					} else if (freeProfit + maxMine.alreadyFree < maxFree && freeProfit + maxMine.alreadyFree +
						speedProfit >= maxFree) {
						this.nodeData[maxActive].waitTakeProfit = maxFree - maxMine.alreadyFree;
					}
					this.nodeData[maxActive].waitTakeProfit = Math.round(this.nodeData[maxActive].waitTakeProfit *
						100) / 100;
					if (this.nodeData[maxActive].waitTakeProfit == 0) this.nodeData[maxActive].btnCaption = "hide";
					else this.nodeData[maxActive].btnCaption = Lang[lg].t_85;
					//计算加速
					let profit = maxMine.takeTime - maxMine.buyTime;
					profit = this.getMinePrice(maxActive) * 1.3 / maxMine.period * profit; //没有加速应该这么多					
					profit = maxMine.alreadyFree - profit;
					if (profit >= 0) this.speedFree = Math.round(profit * 100) / 100;
				}
				this.totalMine = Number(user.totalMine) / 100;
				this.totalMineProfit = Math.round(user.totalMine * 3 / 10) / 100;
				this.totalWaitFree = Math.round((this.totalMine * 1.3 - this.totalAlreadyFree / 100) * 100) / 100;
			},
			onNodeBtnClick(index) {
				let item = this.nodeData[index];
				if (item.isActive == 0 || item.isActive == 1) this.buyNode(item);
				else if (item.isActive == 2) this.OpenNode(item);
				else if (item.isActive == 3) this.takeProfit(item);
			},
			
			async buyNode(item) {

				this.buyNodeName = item.name;
				this.isShowBuyNodeBox = true;
				const age = await conAGE.balanceOf(Account).call(); //余额
				this.balanceOfAGE = Number(age) / 100;
				const user = await conMine.getPeopleTree(Account).call();
				this.balanceOfAccount = Number(user.balanceOf) / 100;
				this.radioSelect = 3;
				var that = this;
				let isOk = await new Promise((resolve) => {
					document.getElementById("radio_close_btn").onclick = () => {
						that.isShowBuyNodeBox = false;
						resolve(false);
					};
					document.getElementById("radio_cancel_btn").onclick = () => {
						that.isShowBuyNodeBox = false;
						resolve(false);
					};
					document.getElementById("radio_ok_btn").onclick = () => {
						that.isShowBuyNodeBox = false;
						resolve(true);
					};
				})
				if (!isOk) return;
				const bnb = await web3.eth.getBalance(Account);
				if (web3.utils.fromWei(bnb) <= 0.001) {
					MsgBox.open(Lang[lg].t_8, Lang[lg].t_86);
					return;
				}

				try {
					if (await gasIsEnough() == false) return;
					if (this.radioSelect == 2 || this.radioSelect == 3) {

						//先授权
						let allowance = await conAGE.allowance(Account, addrMine).call();
						let age = Number(this.getMinePrice(item.id)) * 100;
						if (this.radioSelect == 3) age = age - Number(user.balanceOf);
						if (allowance < age) { //授权
							MsgBox.waitTX(Lang[lg].t_12, Lang[lg].t_87);
							let par = {
								from: Account,
								to: addrAGE,
								gasPrice: await web3.eth.getGasPrice(),
								nonce: await web3.eth.getTransactionCount(Account)
							};
							const gas = await conAGE.approve(addrMine, age).estimateGas(par);
							par.gas = gas;
							await conAGE.approve(addrMine, age).send(par);
						}
					}

					MsgBox.waitTX(Lang[lg].t_88, Lang[lg].t_89 + (Number(item.id) + 1) + Lang[lg].t_3);
					let par = {
						from: Account,
						to: addrMine,
						value: web3.utils.toWei("0.001"),
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};

					const gas = await conMine.buyMine(item.id, this.radioSelect).estimateGas(par);
					par.gas = gas;
					const success = await conMine.buyMine(item.id, this.radioSelect).send(par);
					MsgBox.open(Lang[lg].t_88, Lang[lg].t_90);
					item.isActive = 2;
					this.showUI();

					this.OpenNode(item);
				} catch (e) {
					MsgBox.open(Lang[lg].t_88, e.message);
				}
			},
			async OpenNode(item) {

				if (item.isActive != 2) return;
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_91, Lang[lg].t_92 + (Number(item.id) + 1) + Lang[lg].t_3);
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};

					const gas = await conMine.openMine(item.id).estimateGas(par);
					par.gas = gas;
					const success = await conMine.openMine(item.id).send(par);
					MsgBox.open(Lang[lg].t_91, Lang[lg].t_93);

					this.showUI();
				} catch (e) {
					MsgBox.open(Lang[lg].t_91, e.message);
				}
			},
			async takeProfit(item) {

				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_94, Lang[lg].t_95 + (Number(item.id) + 1) + Lang[lg].t_96);
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};

					const gas = await conMine.take_out_profit(item.id).estimateGas(par);
					par.gas = gas;
					const success = await conMine.take_out_profit(item.id).send(par);
					MsgBox.open(Lang[lg].t_94, Lang[lg].t_97);
					this.showUI();

				} catch (e) {
					MsgBox.open(Lang[lg].t_94, e.message);
				}
			},
			async oneKeyTakeProfit() {

				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_98, Lang[lg].t_98);
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};

					const gas = await conMine.one_key_take_out_profit().estimateGas(par);
					par.gas = gas;
					const success = await conMine.one_key_take_out_profit().send(par);
					MsgBox.open(Lang[lg].t_98, Lang[lg].t_99);
					this.showUI();

				} catch (e) {
					MsgBox.open(Lang[lg].t_98, e.message);
				}
			}
		},
	}
</script>
<style>
	/* 容器样式 */
	.date-container {
		font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
		display: inline-block;
	}

	.date-selector {
		background-color: #000000;
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
		width: 320px;
		overflow: hidden;
	}

	/* 头部样式 */
	.date-header {
		background-color: #111111;
		padding: 16px;
		border-bottom: 1px solid #333333;
	}

	.date-title {
		color: #ffffff;
		font-size: 18px;
		font-weight: 600;
	}

	/* 内容区域 */
	.date-content {
		padding: 0px 12px;
	}

	/* 年份选择区域 */
	.date-year-section {}

	.date-year-header {
		display: flex;
		justify-content: space-between;
		align-items: center;

	}

	.date-current-year {
		color: #ffffff;
		font-size: 20px;
		font-weight: 600;
	}

	.date-nav-btn {
		background-color: #222222;
		color: #ffffff;
		border: none;
		width: 32px;
		height: 32px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.2s;
	}

	.date-nav-btn:hover {
		background-color: #333333;
	}

	.date-year-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 8px;
	}

	.date-year-item {
		background-color: #222222;
		color: #cccccc;
		border-radius: 4px;
		padding: 10px 0;
		text-align: center;
		cursor: pointer;
		transition: all 0.2s;
		font-size: 14px;
	}

	.date-year-item:hover {
		background-color: #333333;
		color: #ffffff;
	}

	.date-year-item.date-selected {
		background-color: #0066cc;
		color: #ffffff;
		font-weight: 600;
	}

	/* 月份选择区域 */
	.date-month-section {}

	.date-month-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 8px;
	}

	.date-month-item {
		background-color: #222222;
		color: #cccccc;
		border-radius: 4px;
		padding: 12px 0;
		text-align: center;
		cursor: pointer;
		transition: all 0.2s;
		font-size: 14px;
	}

	.date-month-item:hover {
		background-color: #333333;
		color: #ffffff;
	}

	.date-month-item.date-selected {
		background-color: #0066cc;
		color: #ffffff;
		font-weight: 600;
	}

	/* 底部按钮 */
	.date-footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		padding-top: 16px;
		border-top: 1px solid #333333;
	}

	.date-btn {
		padding: 8px 20px;
		border-radius: 4px;
		border: none;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.2s;
	}

	.date-confirm {
		background-color: #0066cc;
		color: #ffffff;
	}

	.date-confirm:hover {
		background-color: #0055aa;
	}

	.date-cancel {
		background-color: #333333;
		color: #cccccc;
	}

	.date-cancel:hover {
		background-color: #444444;
		color: #ffffff;
	}

	/*表格*/
	.data-table {
		width: 100%;
		border-collapse: collapse;
		
		/* 保证表格足够宽以容纳所有列 */
	}

	.data-table thead {
		position: sticky;
		top: 0;
		z-index: 10;
		background-color: #2c3e50;
	}

	.data-table th {
		padding: 12px 10px;
		text-align: left;
		font-weight: 600;
		color: #fff;
		border-right: 1px solid #111;
		white-space: nowrap;
		min-width: 12px;
		font-size: 14px;
	}

	.data-table th:last-child {
		border-right: none;
	}

	.data-table tbody tr {
		border-bottom: 2px solid #333;
		cursor: pointer;
		transition: background-color 0.2s;
	}

	.data-table tbody tr:nth-child(even) {
		/*background-color: #f9f9f9;*/
	}

	.data-table tbody tr:hover {
		background-color: #333;
	}

	.data-table td {
		padding: 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 200px;
		font-size: 13px;
		border-right: 1px solid #555;
	}

	.data-table td:last-child {
		border-right: none;
	}
</style>